import s from '../Account.module.css';
import React, {useState} from "react";
import BuyButton from "../../../assets/Components/StyledComponents/BuyButton";
import {readUserData, setUserInfo} from "../../../firebase";
import {useDispatch, useSelector} from "react-redux";
import {checkData} from "../../../assets/Tools/checkData";
import {showSendMessage} from "../../../assets/Tools/showSendMessage/showSendMessage";
import IsSended from "../../../assets/Components/isSended/isSended";
import {setUserData} from "../../../store/UserInfoSlice";


const EditProfile = () => {
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [phone, setPhone] = useState("");
    const [isSended, setIsSended] = useState(false);

    const userId = useSelector(state => state.authUser.userId);
    const dispatch = useDispatch();

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = {
            email,
            name,
            surname,
            phone
        }

        setUserInfo(userId, checkData(data));
        readUserData(userId).then((userInfo) => {
            dispatch(setUserData({
                name: userInfo.name,
                surname: userInfo.surname,
                phone: userInfo.phone,
                country: userInfo.country,
                region: userInfo.region,
                city: userInfo.city,
                address: userInfo.address,
            }))
        });
        setEmail("");
        setName("");
        setSurname("");
        setPhone("");
        showSendMessage(setIsSended);
    }


    return (
        <div className={s.editProfile}>
            <h3>РЕДАКТИРОВАТЬ ВАШУ УЧЕТНУЮ ЗАПИСЬ</h3>
            {isSended ? <IsSended message="Данные успешно измененые"/> : null}
            <form onSubmit={(e) => handleSubmit(e)}>
                <div>
                    <h5>Ваше имя:</h5>
                    <input value={name} onChange={(e) => setName(e.target.value)} type="text"/>
                </div>
                <div>
                    <h5>Ваша фамилия:</h5>
                    <input value={surname} onChange={(e) => setSurname(e.target.value)} type="text"/>
                </div>
                <div>
                    <h5>E-mail:</h5>
                    <input value={email} onChange={(e) => setEmail(e.target.value)} type="email"/>
                </div>
                <div>
                    <h5>Телефон:</h5>
                    <input value={phone} onChange={(e) => setPhone(e.target.value)} type="tel"/>
                </div>
                <div>
                    <BuyButton type="submit">ПРОДОЛЖИТЬ</BuyButton>
                </div>

            </form>
        </div>

    )
}


export default EditProfile;